import { createSlice } from '@reduxjs/toolkit'
import { getDashboardData } from '../../builders/dashboard/dashboard.builder'

const initialState = {
  dashboardData: null,
  loading: null,
}

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    clearExtraReducers: (state) => {
      state.loading = false
      state.dashboardData = null
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getDashboardData.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getDashboardData.fulfilled, (state, action) => {
      state.dashboardData = action.payload
      state.loading = false
    })
    builder.addCase(getDashboardData.rejected, (state) => {
      state.loading = false
    })
  },
})

export const { dashboardData, loading } = dashboardSlice.actions

export default dashboardSlice.reducer
